import { assertUnreachable } from "@aprao/common/src/assertUnreachable.js";
import {
  type BigFraction,
  bigFractionFromNumber,
} from "@aprao/common/src/math/BigFraction.js";
import { convertRate, irr, RateInterval } from "node-irr";

import type { CashflowPeriodGranularity } from "../shapes/ShapeAppraisal.js";

/**
 * Compute the annual IRR based on the given cash flows.
 */
export const computeAnnualIrr = (
  cashflows: Array<BigFraction>,
  granularity: CashflowPeriodGranularity,
): BigFraction | null => {
  const periodIrr = irr(cashflows.map((f) => f.valueOf()));
  const annualIrr =
    granularity === "monthly" ?
      convertRate(periodIrr, RateInterval.Year, RateInterval.Month)
    : granularity === "annual" ? periodIrr
    : assertUnreachable(granularity);

  return Number.isFinite(annualIrr) ? bigFractionFromNumber(annualIrr) : null;
};
